import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function useAdFree() {
  const { user } = useAuth();
  const [adFree, setAdFree] = useState(false);
  const [reason, setReason] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAdFreeStatus = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/ads/check-ad-free`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setAdFree(data.ad_free);
        setReason(data.reason);
      }
    } catch (err) {
      console.log('Failed to check ad-free status');
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAdFreeStatus();
  }, [checkAdFreeStatus, user]);

  return { adFree, reason, loading, refresh: checkAdFreeStatus };
}
